import {Redirect, Route} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {storesContext} from "../../../stores/stores";
import {RoutingModel} from "../../../models/routing";
import {observer} from "mobx-react";
import {AuthService} from "../../../services/authService";
import Loader from "../loader/loader";

function RouteWithSubRoutes(route: RoutingModel) {
    const userStore = useContext(storesContext).userStore;
    const [display, setDisplay] = useState(route.roles && userStore.hasRole(route.roles) || !route.roles);
    const [doRequest, setDoRequest] = useState(!userStore.roles || !userStore.roles.length);

    useEffect(() => {
        if (doRequest) {
            AuthService.authenticatedUser().then((responseAuthenticatedUser) => {
                userStore.setRoles(responseAuthenticatedUser?.roles || []);
                setDisplay(route.roles && userStore.hasRole(route.roles) || !route.roles);
                setDoRequest(false);
            });
        }
    }, []);

    return (
        <Route
            path={route.path}
            render={props => {
                if (display) {
                    const RouteComponent = route.component as typeof React.Component;
                    return <RouteComponent {...props} routes={route.routes}/>;
                } else if (doRequest) {
                    return <Loader/>;
                } else {
                    return <Redirect to={{pathname: "/"}}/>;
                }
            }}
        />
    );
}

export default observer(RouteWithSubRoutes);
